<template>
    <el-dialog title="在线调款" :visible.sync="visible" width="1200px" :before-close="handleClose" :close-on-click-modal="false" append-to-body>
        <div class="hw-content">
            <div class="content-content">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">
                                <span class="required">*</span>
                                调出ERP订单号：
                            </div>
                            <div>
                                <el-input autocomplete="on" name="ERP_Code"  v-model="TransferAdd.ERP_Code" placeholder="请输入ERP订单号" clearable class="el-select-max"></el-input>
                                <el-button :loading="Record_loading" type="primary" style="margin-left: 10px" @click="getGSTOrderPaymentListByERPSN(TransferAdd.ERP_Code)">查询</el-button>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24" v-if="RecordInfo.ORDER_NO">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">调出ERP订单信息：</div>
                            <div>
                                <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                                    <el-descriptions-item label="订单号">
                                        <div class="row-content">{{ RecordInfo.ORDER_NO }}</div>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="订单金额">
                                        <div class="row-content">{{ RecordInfo.OrderAmount }}</div>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="业务员">
                                        <div class="row-content">{{ RecordInfo.SalesmanName }}[{{ RecordInfo.SalesmanCode }}]</div>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="日期">{{ RecordInfo.OrderCreateDate }}</el-descriptions-item>
                                    <el-descriptions-item label="客户号 ">{{ RecordInfo.CUSTOMER_NO }}</el-descriptions-item>
                                    <el-descriptions-item label="客户名称">{{ RecordInfo.CUSTOMER_NAME }}</el-descriptions-item>
                                    <el-descriptions-item label="工程名称">{{ RecordInfo.PROJECT_NAME }}</el-descriptions-item>
                                    <el-descriptions-item label="分支机构">{{ RecordInfo.REGION_CODE }}</el-descriptions-item>
                                </el-descriptions>
                            </div>
                        </div>
                    </el-col>

                    <el-col :span="24" v-if="RecordInfo.ORDER_NO">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">分款记录：</div>
                            <div>
                                <el-table ref="multipleTable" @selection-change="handleSelectionChange" :data="RecordInfo.OrderPaymentRecordInfo" style="width: 1000px" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                                    <el-table-column prop="VoucherType" label="凭证类型" align="center" width="80"></el-table-column>
                                    <el-table-column prop="InAccountBrank" label="汇入银行" align="center"></el-table-column>
                                    <el-table-column prop="VoucherText" label="汇款单位" align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="PaymentDate" label="付款日期" align="center"></el-table-column>
                                    <el-table-column prop="PaymentAmount" label="汇款金额" align="center">
                                        <template slot-scope="scope">
                                            <div>￥{{ scope.row.PaymentAmount }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="AllocateAmount" label="分款金额" align="center">
                                        <template slot-scope="scope">
                                            <div>￥{{ scope.row.AllocateAmount }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="DistributeDate" label="分款日期" align="center">
                                        <template v-slot="scope">
                                            {{ scope.row.DistributeDate | formatDate }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="TransferAmount" label="可调出金额" align="center"></el-table-column>
                                    <el-table-column prop="prop" label="调款金额" align="center">
                                        <template v-slot="scope">
                                            <div>
                                                <el-input v-model="scope.row.amount" placeholder="" @blur="handleBlur(scope.row)" @input="handleInput(scope.row)"></el-input>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-col>

                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">
                                <span class="required">*</span>
                                调入订单号：
                            </div>
                            <el-input autocomplete="on" name="ERP_Code_Enter"  v-model="TransferAdd.ERP_Code_Enter" placeholder="请输入商城订单或ERP订单号" clearable class="el-select-max"></el-input>
                            <el-button type="primary" :loading="ERP_order_loading" style="margin-left: 10px" @click="getGSTERPOrdersByERPSN(TransferAdd.ERP_Code_Enter)">查询</el-button>
                        </div>
                    </el-col>
                    <el-col :span="24" v-if="ERP_order_info.ORDER_NO">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">调入ERP订单信息：</div>
                            <div>
                                <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                                    <el-descriptions-item label="订单号">
                                        <div class="row-content">{{ ERP_order_info.ORDER_NO }}</div>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="订单金额">
                                        <div class="row-content">{{ ERP_order_info.ORDER_AMOUNT }}</div>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="业务员">
                                        <div>{{ ERP_order_info.Sales_name }}[{{ ERP_order_info.SALESMAN_CODE }}]</div>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="日期">{{ ERP_order_info.Date_Entered }}</el-descriptions-item>
                                    <el-descriptions-item label="客户号 ">{{ ERP_order_info.CUSTOMER_NO }}</el-descriptions-item>
                                    <el-descriptions-item label="客户名称">{{ ERP_order_info.Customer_name }}</el-descriptions-item>
                                    <el-descriptions-item label="工程名称">{{ ERP_order_info.PROJECT_NAME }}</el-descriptions-item>
                                    <el-descriptions-item label="分支机构">{{ ERP_order_info.REGION_CODE }}</el-descriptions-item>
                                    <el-descriptions-item label="可分款金额">
                                        <span style="color: red">￥{{ ERP_order_info.Divisible_Amount }}</span>
                                    </el-descriptions-item>
                                </el-descriptions>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">附件：</div>
                            <div>
                                <!-- <Hwupload ref="Hwupload" @onSuccess="onSuccess" @removeFile="removeFile" /> -->
                                <Hwupload ref="Hwupload" @ontempList="ontempList"></Hwupload>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div slot="footer" style="display: flex; justify-content: center">
            <el-button @click="handleClose()">取 消</el-button>
            <el-button type="primary" @click="onSubmit()">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { cloneDeep, debounce } from 'lodash';
import { downloadFile, toLowerCaseKeys } from '@/utils/utils.js';
// import Hwupload from '@/components/Hwupload/index.vue';
import Hwupload from '@/components/Hwupload/indexMany';
export default {
    name: 'AddPaymentDialog',
    components: {
        Hwupload
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            ERP_order_loading: false,
            Record_loading: false,

            TransferAdd: {},
            RecordInfo: {},
            ERP_order_info: {},
            fileList: [],
            multipleSelection: []
        };
    },
    methods: {
        // 上传成功
        onSuccess(e) {
            this.TransferAdd.apply_attachment = e;
        },
        ontempList(list) {
            this.fileList = list;
            console.log(list);
        },
        removeFile() {},
        // 调出订单详情
        getGSTOrderPaymentListByERPSN(Orders_ERPSN) {
            this.Record_loading = true;
            this.$newsApi
                .getGSTOrderPaymentListByERPSN({ Orders_ERPSN })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.RecordInfo = res.data.data;
                        this.$nextTick(() => {
                            this.RecordInfo.OrderPaymentRecordInfo.forEach((item) => {
                                this.$set(item, 'amount', ''); // 确保每个 item 的 amount 属性是响应式的
                                this.$refs.multipleTable.toggleRowSelection(item, true);
                            });
                        });
                    }
                })
                .finally(() => (this.Record_loading = false));
        },
        //调入订单详情
        getGSTERPOrdersByERPSN(Orders_ERPSN) {
            this.ERP_order_loading = true;
            this.$newsApi
                .getGSTERPOrdersByERPSN({ Orders_ERPSN })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.ERP_order_info = res.data.data;
                    }
                })
                .finally(() => (this.ERP_order_loading = false));
        },
        //多选
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        handleInput(row) {
            row.amount = this.formatMoneyOnInput(row.amount);
        },
        handleBlur(row) {
            row.amount = this.formatMoneyOnBlur(row.amount);
        },
        removeFileList(index) {
            this.fileList.splice(index, 1);
        },

        onSubmit: debounce(function () {
            if (!this.RecordInfo.ORDER_NO) {
                this.$message({
                    message: '调出的ERP订单信息为空',
                    type: 'warning'
                });
                return;
            }
            if (!this.ERP_order_info.ORDER_NO) {
                this.$message({
                    message: '订单信息为空',
                    type: 'warning'
                });
                return;
            }
            const result = cloneDeep(toLowerCaseKeys(this.TransferAdd));
            result.erp_code = this.RecordInfo.ORDER_NO;
            result.erp_code_enter = this.ERP_order_info.ORDER_NO;
            result.apply_attachment = this.fileList.join('|');
            const OrderPaymentRecordInfo = this.RecordInfo.OrderPaymentRecordInfo.filter((item) => this.multipleSelection.some((el) => el.OBJID == item.OBJID));
            console.log(OrderPaymentRecordInfo, 'OrderPaymentRecordInfoOrderPaymentRecordInfo');
            OrderPaymentRecordInfo.forEach((element) => {
                result['objid_' + element['OBJID']] = element['OBJID'];
                result['transfer_amount_' + element['OBJID']] = element['amount'];
            });
            this.$newsApi.getAddOrdersDistributetTransfer({ json: JSON.stringify(result) }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.handleClose();
                    this.$emit('success');
                } else {
                    this.$alert(res.data.Resultinfo, '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                }
            });
        }, 800),
        
        handleClose() {
            this.$emit('update:visible', false);
            this.resetForm();
        },
        
        resetForm() {
            this.TransferAdd = {};
            this.RecordInfo = {};
            this.ERP_order_info = {};
            this.fileList = [];
            this.multipleSelection = [];
            // 清空上传组件的状态
            if (this.$refs.Hwupload) {
                this.$refs.Hwupload.fileList = [];
                this.$refs.Hwupload.templist = [];
            }
        }
    }
};
</script>
<style scoped lang="scss">
.content {
    background: #fff;
}
.hw-content {
    padding: 20px;
}
/* #f5f7fa */
/deep/ .custom-label {
    text-align: right !important;
    width: 170px;
    color: #333333;
    background: #f5f7fa !important;
}

/deep/.hw-form-item-label {
    font-size: 14px;
}
.content-content {
    padding: 20px 0;
}
.action-title-top {
    padding-bottom: 15px;
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 15px;
}

.rows {
    width: 389px;
}
.row-content {
    width: 200px;
}
.descriptions-item-content-rows {
    width: 150px;
}
.hw-content {
    padding: 0px 20px;
}
.ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 150px;
    }
}
</style>
